import React from 'react';

class SchoolMainDetails extends React.Component {
  render() {
    const school = this.props.school;

    if (!school) {
      return 'SCHOOL MISSING';
    }

    return (
      <div>
        {
          this.props.showName && (
            <div>
              <h2><i className={school.parent_school ? 'fa fa-university' : 'fa fa-school'} /> {school.name}</h2>
              <p style={{fontSize: '150%', color: '#888'}}>{school.type}</p>
            </div>
          )
        }

        <p>
          <strong>ID/ C.M.:</strong> {school['id']}
        </p>
        <p>
          <strong>Indirizzo:</strong><br />
          {school.address}<br />
          {school.postcode} {school.city_name} {school.province_iso_code ? '(' + school.province_iso_code + ')' : ''}<br />
          {school.country}
        </p>
        <p>
          <strong>Email:</strong> {school['email'] ? <a href={'mailto:' + school['email']}>{school['email']}</a> : 'N/D'}<br />
          <strong>PEC:</strong> {school['certified_email'] ? <a href={'mailto:' + school['certified_email']}>{school['certified_email']}</a> : 'N/D'}<br />
          <strong>Sito web:</strong> {school['website'] ? <a href={school['website']}>{school['website']}</a> : 'N/D'}<br />
        </p>

        <p>
          <strong>Twitter:</strong> {school['twitter_url'] ? <a href={school['twitter_url']}>{school['twitter_url']}</a> : 'N/D'}<br />
          <strong>Facebook:</strong> {school['facebook_url'] ? <a href={school['facebook_url']}>{school['facebook_url']}</a> : 'N/D'}<br />
        </p>
      </div>
    );
  }
}

export default SchoolMainDetails;



// WEBPACK FOOTER //
// ./src/components/schools/SchoolMainDetails.js